<template>
    <el-form-item :label="$t('general.filters.portalCategory')">
        <el-select
                :placeholder="$t('general.filters.portalCategoryPlaceholder')"
                clearable
                @input="setCategory"
                :value="filter.category"
        >
            <el-option
                    style="text-transform:capitalize"
                    v-for="(value, key) in this.listCategories"
                    :label="capitalize(value)"
                    :value="key"
            >
            </el-option>
        </el-select>
    </el-form-item>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { chargerCategories } from '@/services/portals'

export default {
  name: 'Categories',
  props: ['excludedCategories'],
  data: function () {
    return {
      listCategories: []
    }
  },
  computed: {
    ...mapState('portals', ['filter'])
  },
  methods: {
    ...mapMutations('portals', [
      'setCategory'
    ]),
    capitalize (string) {
      if (!string) return ''
      return string.charAt(0).toUpperCase() + string.substr(1)
    }
  },
  async mounted () {
    if (this.$store.getters['donnees/getCategoryPortals'] == null) {
      this.listCategories = await chargerCategories(this.$store.getters.getSitimmoUser.metier)
      if (this.listCategories.type === 'error') {
        return false
      }
    } else {
      this.listCategories = this.$store.getters['donnees/getCategoryPortals']
    }
    if (this.excludedCategories) {
      const categories = this.excludedCategories.split(',')
      categories.forEach((element) => delete this.listCategories[element])
    }
  }
}
</script>

<style scoped>

</style>
